<button
  #trigger="cdkOverlayOrigin"
  cdkOverlayOrigin
  mat-icon-button
  matTooltip="Hide or Show Columns"
  type="button"
  (click)="$event.stopPropagation(); toggleFilter()"
>
  <mat-icon>view_column</mat-icon>
</button>

<ng-template
  cdkConnectedOverlay
  cdkConnectedOverlayBackdropClass="cdk-overlay-transparent-backdrop"
  [cdkConnectedOverlayOrigin]="trigger"
  [cdkConnectedOverlayOpen]="showFilter"
  [cdkConnectedOverlayPanelClass]="'ag-table-column-panel'"
  [cdkConnectedOverlayHasBackdrop]="true"
  (backdropClick)="toggleFilter(); this.createColumns(tableGridColumns)"
>
  <mat-card appearance="outlined">
    <div [formGroup]="form">
      <mat-card-content>
        <mat-form-field>
          <input
            agAutofocus
            type="text"
            matInput
            formControlName="filter"
            appearance="flat"
            autocomplete="off"
            [placeholder]="placeholder"
            (keyup)="filter($event)"
          />
          @if (form.get('filter').value.length) {
            <button mat-icon-button matSuffix type="button" (click)="clear()">
              <mat-icon>close</mat-icon>
            </button>
          } @else {
            <button mat-icon-button matSuffix disabled type="button">
              <mat-icon>search</mat-icon>
            </button>
          }
        </mat-form-field>

        <mat-selection-list>
          @for (item of filteredColumns; track item) {
            <mat-list-option
              [value]="item.value"
              [selected]="item.display"
              (click)="toggleDisplayedColumn(item)"
            >
              {{ item.label }}
            </mat-list-option>
          }
        </mat-selection-list>
      </mat-card-content>
    </div>
  </mat-card>
</ng-template>
